
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(598|643|667|766)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
